import React from 'react';

import { PromotionSectionCard } from './PromotionSectionCard';
import { MultiSelectDropdown } from '../../component/MultiSelectDropdown';
import { TextInput } from '../../component/TextInput';
import { countryToCurrency } from '../../dropdownOptions';
import { Option } from '../../pages/types';

export function ConditionalEligibilitySection({
  eligibleCountry,
  eligibleCountrySelected,

  productOptions,
  selectedConditionalProductIds,
  setSelectedConditionalProductIds,

  minimumSpendAmount,
  setMinimumSpendAmount,
}: {
  eligibleCountry?: Option;
  eligibleCountrySelected: boolean;

  productOptions: Option[];
  selectedConditionalProductIds: Option[];
  setSelectedConditionalProductIds: (opts: Option[]) => void;

  minimumSpendAmount: string;
  setMinimumSpendAmount: (v: string) => void;
}) {
  return (
    <PromotionSectionCard>
      <div className="w-full mb-2">
        <h2>Conditional product(s) for promotion eligibility</h2>
        <div className="flex justify-between space-x-4">
          <div className="w-full">
            <MultiSelectDropdown
              options={productOptions}
              placeholder={
                !eligibleCountrySelected
                  ? 'Select eligible country first'
                  : 'Select conditional product(s)'
              }
              selectedOptions={selectedConditionalProductIds}
              setSelectedOptions={setSelectedConditionalProductIds}
              isDisabled={!eligibleCountrySelected}
            />
          </div>
        </div>
      </div>

      <div className="w-full mb-2">
        <h2>Conditional spend amount for promotion eligibility</h2>
        <div className="flex justify-between space-x-4">
          <div className="w-full flex">
            <h3 className="self-center whitespace-nowrap mr-2">
              {eligibleCountry ? countryToCurrency[eligibleCountry.value] : ''} $
            </h3>
            <TextInput
              placeholder="None"
              value={minimumSpendAmount}
              setTextChange={setMinimumSpendAmount}
            />
          </div>
        </div>
      </div>
    </PromotionSectionCard>
  );
}
